import _slicedToArray from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.map.js";
// Copyright 2017-2022 @polkadot/api-derive authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { combineLatest, map, of, switchMap } from 'rxjs';
import { memo } from "../util/index.js";
import { filterBountiesProposals } from "./helpers/filterBountyProposals.js";

function parseResult(_ref) {
  var _ref2 = _slicedToArray(_ref, 4),
      maybeBounties = _ref2[0],
      maybeDescriptions = _ref2[1],
      ids = _ref2[2],
      bountyProposals = _ref2[3];

  var bounties = [];
  maybeBounties.forEach(function (bounty, index) {
    if (bounty.isSome) {
      bounties.push({
        bounty: bounty.unwrap(),
        description: maybeDescriptions[index].unwrapOrDefault().toUtf8(),
        index: ids[index],
        proposals: bountyProposals.filter(function (bountyProposal) {
          return bountyProposal.proposal && ids[index].eq(bountyProposal.proposal.args[0]);
        })
      });
    }
  });
  return bounties;
}

export function bounties(instanceId, api) {
  var bountyBase = api.query.bounties || api.query.treasury;
  return memo(instanceId, function () {
    return bountyBase.bounties ? combineLatest([bountyBase.bountyCount(), api.query.council ? api.query.council.proposalCount() : of(0)]).pipe(switchMap(function () {
      return combineLatest([bountyBase.bounties.keys(), api.derive.council ? api.derive.council.proposals() : of([])]);
    }), switchMap(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
          keys = _ref4[0],
          proposals = _ref4[1];

      var ids = keys.map(function (_ref5) {
        var _ref5$args = _slicedToArray(_ref5.args, 1),
            id = _ref5$args[0];

        return id;
      });
      return combineLatest([bountyBase.bounties.multi(ids), bountyBase.bountyDescriptions.multi(ids), of(ids), of(filterBountiesProposals(api, proposals))]);
    }), map(parseResult)) : of(parseResult([[], [], [], []]));
  });
}